import { css } from 'lit';
import componentStyles from '../styles/component.styles';
export default css `
  ${componentStyles}
  /**
--------------------------------------------------
* General
--------------------------------------------------
*/
  :host {
    display: block;
  }

  .skeleton {
    background: var(--p-skeleton-bg);
    border-radius: var(--p-skeleton-border-radius, 5px);
    overflow: hidden;
    position: relative;
    animation: 0.5s delay;
    animation-delay: 0.5s;
    animation-fill-mode: forwards;
    opacity: 0;
  }

  .skeleton.no-delay {
    animation-delay: 0s;
  }

  .skeleton::after {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    transform: translateX(-100%);
    background-image: linear-gradient(
      90deg,
      rgba(var(--p-skeleton-loading-rgb), 0) 0,
      rgba(var(--p-skeleton-loading-rgb), 0.2) 20%,
      rgba(var(--p-skeleton-loading-rgb), 0.5) 60%,
      rgba(var(--p-skeleton-loading-rgb), 0)
    );
    animation: shimmer 2s infinite;
    content: '';
  }

  .center {
    margin-left: auto;
    margin-right: auto;
  }

  .shape-circle {
    aspect-ratio: 1/1;
    border-radius: 50%;
  }

  @keyframes delay {
    100% {
      opacity: 1;
    }
  }

  @keyframes shimmer {
    100% {
      transform: translateX(100%);
    }
  }
`;
